export enum DraftJobChangeReason {
  // BLOCKED — shown, never applied
  SPLIT_NOT_SUPPORTED = 'SPLIT_NOT_SUPPORTED',
  FIELD_NOT_SUPPORTED = 'FIELD_NOT_SUPPORTED',
  STEP_STARTED = 'STEP_STARTED',
  // REMOVE
  STEP_CANCELED = 'STEP_CANCELED',
  STEP_COMPLETED = 'STEP_COMPLETED',
  STEP_ON_HOLD = 'STEP_ON_HOLD',
  // SPLIT_JOB / ADD_JOB / REMOVE_JOB
  ORDER_ADDED_A_LEG = 'ORDER_ADDED_A_LEG',
  ORDER_ADDED_A_PACKAGE = 'ORDER_ADDED_A_PACKAGE',
  STEP_LEFT_THE_ORDER = 'STEP_LEFT_THE_ORDER',
  ALL_PACKAGES_REMOVED = 'ALL_PACKAGES_REMOVED',
  // FAILED — set at apply time (failureReason)
  NOTHING_TO_SYNC = 'NOTHING_TO_SYNC',
  CHANGE_RECLASSIFIED = 'CHANGE_RECLASSIFIED',
  REMOVE_BLOCKED_JOB_LOCKED_TO_ROUTE = 'REMOVE_BLOCKED_JOB_LOCKED_TO_ROUTE',
  DISPATCHED_ROUTE_EDITS_DISABLED = 'DISPATCHED_ROUTE_EDITS_DISABLED'
}
